module.exports = __webpack_public_path__ + "static/img/159852400.78ea8e93.png";